import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { AlertService } from 'src/app/shared/alert/service/alert.service';
import { ERROR_CODE_BAD_REQUEST, ERROR_CODE_CONFLICT, ERROR_CODE_SERVER_ERROR, ErrorCodeInspections } from 'src/app/wap/configuration/inspections/models/error.code';
import { EnvService } from '../deployment/env.service';

@Injectable()
export class ManageErrorsService {
  constructor(
    private alertService: AlertService,
    private env: EnvService
  ) {}

  public showError(err: HttpErrorResponse) {
    if (err.error instanceof Blob) {
      from(err.error.text()).subscribe({
        next: (text) => {
          let body: unknown;
          try {
            body = JSON.parse(text);
          } catch (error) {
            if (!(error instanceof SyntaxError)) {
              throw error;
            }
            this.alertService.error(text || err.message);
            return;
          }
          this.showError(
            new HttpErrorResponse({
              error: body,
              headers: err.headers,
              status: err.status,
              statusText: err.statusText,
              url: err.url,
            })
          );
        },
        error: () => this.alertService.error(err.message),
      });
      return;
    }

    const message = this.manageCustomErrors(err);

    if (message) {
      this.alertService.error(message);
    }
  }

  public showWarning(err: HttpErrorResponse) {
    this.alertService.warn('****'.concat(err.message));
  }

  public showInfo(err: HttpErrorResponse) {
    this.alertService.info('****'.concat(err.message));
  }

  public showSuccess(err: HttpErrorResponse) {
    this.alertService.success('****'.concat(err.message));
  }

  private manageCustomErrors(error: HttpErrorResponse): null | string {
    const body: unknown = error.error;
    const detail = typeof body === 'object' && body !== null && 'detail' in body && typeof body.detail === 'string' ? body.detail : typeof body === 'string' ? body : error.message;
    switch (error.status) {
      case ERROR_CODE_BAD_REQUEST:
        if (typeof body === 'object' && body !== null && 'ClassName' in body && body.ClassName === ErrorCodeInspections.PendingPunches && 'Message' in body && typeof body.Message === 'string') {
          this.alertService.warn(`There is a problem in this action: ${body.Message}`);
          return null;
        }
        if (Array.isArray(body) && this.mapErrors(body)) {
          return null;
        }
        return this.env.dev_mode ? JSON.stringify(error) : detail;
      case ERROR_CODE_CONFLICT:
        this.alertService.warn(this.env.dev_mode ? JSON.stringify(error) : detail);
        return null;
      case ERROR_CODE_SERVER_ERROR:
        this.alertService.error(this.env.dev_mode ? JSON.stringify(error) : 'Error => ' + error.statusText);
        return null;
      default:
        return this.env.dev_mode ? JSON.stringify(error) : error.message;
    }
  }

  mapErrors(errs: unknown[]): boolean {
    let displayed = false;
    for (const err of errs) {
      if (typeof err !== 'object' || err === null || !('errorMessage' in err) || typeof err.errorMessage !== 'string' || !err.errorMessage) {
        continue;
      }
      if ('propertyName' in err && typeof err.propertyName === 'string' && err.propertyName) {
        this.alertService.warn('Error => Property: ' + err.propertyName + ', Message: ' + err.errorMessage, true);
      } else {
        this.alertService.warn(err.errorMessage, true);
      }
      displayed = true;
    }
    return displayed;
  }
}
